import type { CylinderSurface, FlatSurface } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import type { PhotoDimensions } from '@/entities/edit-area';

interface SurfaceOutlineOverlayProps {
  readonly surface: FlatSurface | CylinderSurface;
  readonly photoSize: PhotoDimensions;
}

/**
 * 추출한 윤곽 — 가는 선 하나다. 점 핸들이 없고 포인터도 받지 않는다(윤곽은 '다시 추출하기'로만 바꾼다).
 */
export const SurfaceOutlineOverlay = ({
  surface,
  photoSize,
}: SurfaceOutlineOverlayProps): ReactElement | null => {
  const outline = surface.outline;
  if (outline === undefined) return null;
  const points = outline.points
    .map(
      (point) => `${(point.x * photoSize.widthPx) / 100},${(point.y * photoSize.heightPx) / 100}`,
    )
    .join(' ');
  return (
    <polygon
      points={points}
      fill="#2563eb14"
      stroke="#2563eb"
      strokeWidth={1}
      strokeOpacity={0.6}
      vectorEffect="non-scaling-stroke"
      pointerEvents="none"
      data-testid={`surface-outline-${surface.id}`}
    />
  );
};
